import React                                      from 'react'
import { Icon, Button, Tooltip }                  from 'antd'
import prettysize                                 from '../../utils'
import {sanitize_path, is_supported_video_format} from "../../utils"

import './file-info.scss'

export default ({ file, on_download, on_delete, on_copy_dll,
                  on_share, on_show_media_info, on_play }) => {
  const {key, bucket_name, download_url, play, project_name, path, mime_type, size, type} = file||{}
  return (
    <div className='file-info'>
      <div className='file-name-container'>
        {
          play && download_url &&
          <video className={'player'} width={450} poster={''}
                 autoPlay controls controlsList="nodownload">
            <source src={download_url} type="video/mp4"/>
            Your browser does not support HTML5 video
          </video>
        }

        <Icon type='file-text' className='file-icon'/>
        <p className='file-name'>{key}</p>
        <span className={'root-path'}>{`${project_name||''} ${bucket_name}/${sanitize_path(path, true)}`}</span>

        <div className='file-actions'>
          <Tooltip placement='bottom' title='Download'>
            <Button ghost type='primary' shape='circle' icon='download' size='small' onClick={()=>on_download(file)}/>
          </Tooltip>
          <Tooltip placement='bottom' title='Share'>
            <Button ghost type='primary' shape='circle' icon='share-alt' size='small' onClick={()=> on_share(file)}/>
          </Tooltip>
          <Tooltip placement='bottom' title='Show details'>
            <Button ghost type='primary' shape='circle' icon='info' size='small' onClick={()=> on_show_media_info(file)}/>
          </Tooltip>
          <Tooltip placement='bottom' title='Copy download link'>
            <Button ghost type='primary' shape='circle' icon='copy' size='small' onClick={()=> on_copy_dll(file)}/>
          </Tooltip>

          {
            is_supported_video_format(key) &&
            <Tooltip placement='bottom' title={play ? 'Close video':'Play video'}>
              <Button ghost type='primary' shape='circle' icon={play ?'close': 'play-circle-o'} size='small' onClick={()=> on_play(file)}/>
            </Tooltip>
          }

        </div>
      </div>
      <div className='file-infos'>
        <p>
          <span className='file-info-key'>Format</span>
          <span className='file-info-value'>{mime_type}</span>
        </p>
        <p>
          <span className='file-info-key'>Size</span>
          <span className='file-info-value'>{prettysize(size)}</span>
        </p>
      </div>
    </div>
  )
}
